<template>
  <modal-cont class="modal-form" :closeTo="closeTo">
    <modal-close @click.native="$store.dispatch('GO_BACK', { $router, fallback: closeTo })"/>
    <slot/>
  </modal-cont>
</template>

<script>
export default {
  props: {
    closeTo: {
      default: 'Board',
    },
  },
}
</script>

<style lang="scss">
@import '~style/variables';

.modal-form .modal {
  > .name {
    border-bottom: 1px solid $c-border;
    box-shadow: $s-sm;
    font-weight: $medium;
    padding: 0.75rem 1.25rem;
    text-align: left;
  }
  > .form {
    padding: 0.5rem;
    .btn.submit {
      margin-top: 1rem;
    }
    @media screen and (min-width: $res-lg) {
      padding: 1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/ModalForm.vue